module.exports = "export default __webpack_public_path__ + &quot;c1630aabad0645f7da83350ddfd185ab.svg&quot;;"